<script setup>
import { useToggle } from '@vueuse/core';

const props = defineProps({
  title: {
    type: String,
    required: true,
  },
  defaultOpen: {
    type: Boolean,
    default: true,
  },
});

const [isOpen, toggle] = useToggle(props.defaultOpen);
</script>

<template>
  <div
    class="w-full rounded-2xl border border-n-weak bg-white dark:bg-n-solid-2 px-5"
  >
    <div
      class="flex items-center justify-between w-full cursor-pointer py-4"
      @click="toggle()"
    >
      <span class="text-[15px] font-semibold text-n-slate-12 w-full">
        {{ title }}
      </span>
    </div>
    <div
      v-if="isOpen"
      class="w-full space-y-4 border-t border-n-weak pt-4 pb-5"
    >
      <slot />
    </div>
  </div>
</template>
